
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Brand } from '../../../business-entities/brand.model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { RentalCar } from '../../../business-entities/rental-car.interface';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { ImageService } from '../../../services/image.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { BrandService } from '../../../business-services/brand.service';
import { VehicleListViewModel, ModelType } from '../../../business-entities/vehicle-list-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-edit-rental-car',
  templateUrl: './edit-rental-car.component.html'
})
export class EditRentalCarComponent implements OnInit {

  imageBaseData: string | ArrayBuffer = null;
  dealerSelected: string;
  RentalCarInfo: RentalCar;
  id: number;
  editRentalCar = false;
  editRentalCarForm: FormGroup;
  dealerList: SelectListItemViewModel[];
  response: any;
  fuelType: FuelType[];
  dealers: DealerViewModel[] = [];
  fuels: FuelType[] = [];
  rentalCarImageName: string = null;
  brandList: Brand[] = [];
  brand: Brand[];
  color: string;
  image: string | ArrayBuffer;
  isDealerLoggedIn: boolean;
  registrationDate: string;
  charges: string;
  isChargesLengthError: boolean = false;
  isValidRentalPrice: boolean = false;
  licensePlateClass: string = "";
  modelList: ModelType[] = [];
  modelName: string;
  searchVehicleDetails: VehicleListViewModel;
  features: Features[] = [];
  addRentalCarForm: FormGroup;
  selectedAttributes: any;
  keepExtraFieldsMandatory = true;

  constructor(
    private EditRentalCar: RentalCarService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal,
    private imageService: ImageService,
    private Vehicleservice: VehicleBusinessService,
    private brandService: BrandService,
    private secureStorage: SecureStorage,
    private cdr: ChangeDetectorRef,
  ) { }


  ngOnInit(): void {
    this.keepExtraFieldsMandatory = localStorage.getItem("Theme") !== 'mg';
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === Enums.UserRoles.DealerAdmin;
    this.getAllData();
    this.getFeatures();
  }

  async getAllData() {
    this.getId()
    this.spinner.show();
    const dealerDropdownPromise = this.GetAll();
    const fuelDropdownPromise = this.GetAllFuelTypes();
    const brandDropdownPromise = this.GetAllBrand();
    this.id = this.EditRentalCar.RentalCarId
    Promise.all([dealerDropdownPromise, fuelDropdownPromise, brandDropdownPromise]).then(_ => {
      this.GetRentalCarById(this.id);
    })
  }
  get cpf() {
    return this.editRentalCarForm.controls;
  }

  async GetAllFuelTypes() {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuelType = data.responseObject.result;
      this.fuels = this.fuelType.slice();
    })
  }

  getId() {
    if (this.EditRentalCar.dealerId) {
      this.EditRentalCar.isEdit = true;
    }
  }

  async GetAll() {
    this.dealerList = this.EditRentalCar.dealerList;

  }

  onBlur(event) {
    this.charges = event.target.value;
  }
  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.dealerSelected = event.item.text;
  }

 

  OnClose() {
    this.activeModal.close({success : true});
  }

  private async GetRentalCarById(Id: number) {
    this.spinner.show();
    await this.EditRentalCar.GetRentalCarById(Id).then(result => {
      if (result.responseCode == Enums.ErrorCodes.SuccessCode) {
        this.RentalCarInfo = result.responseObject;
        if (this.RentalCarInfo) {
          this.initializeForm();
          if (this.RentalCarInfo.registrationDate) {
            this.registrationDate = this.RentalCarInfo.registrationDate;
          }
          this.selectedAttributes = this.RentalCarInfo.fuel
          this.editRentalCarForm.patchValue({
            ...result.responseObject,
            // dealerName: this.dealers.find(x => x.name === result.responseObject.dealerName).dealerId,
            registrationDate: this.RentalCarInfo.registrationDate ?? ''  ,
            color: this.RentalCarInfo.color ?? '' ,
          })
          this.dealerSelected = this.dealerList.filter(x => (x.value === this.RentalCarInfo.dealerId) ? x.text : '')[0].text;
          this.charges = this.editRentalCarForm.value.charges;
        }
        this.color = this.RentalCarInfo.color ?? '' ;
        this.image = this.RentalCarInfo.rentalCarImage  ?? './../../../assets/images/no-img.png';
      }
      if (result.responseObject.result && result.responseObject.result.errorCode === Enums.ErrorCodes.RentalVehicleNotFound) {
        let errorMessage = this.translate.instant("lblRentalCarNotFound");
        this.toaster.error(errorMessage);
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
  }
  initializeForm(): void {
    this.editRentalCarForm = this.formBuilder.group({
      licensePlatNo: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_ ]*$/)]],
      engineNo: ['', this.keepExtraFieldsMandatory ? [Validators.required] : []],
      color: [''],
      chessisNo: ['', this.keepExtraFieldsMandatory ? [Validators.required] : []],
      charges: ['', [Validators.required]],
      year: ['', this.keepExtraFieldsMandatory ? [Validators.required , Validators.max(new Date().getFullYear()), Validators.min(1850), Validators.pattern(/^\d{4}$/)] : [Validators.max(new Date().getFullYear()), Validators.min(1850), Validators.pattern(/^\d{4}$/)]],
      model: ['', [Validators.required]],
      fuel: ['', this.keepExtraFieldsMandatory ? [Validators.required] : []],
      company: ['', Validators.required],
      dealerName: ['', [Validators.required]],
      registrationDate: [{ value: '', disabled: true }],
      isActive: ['']
    });
    if (this.isDealerLoggedIn) this.cpf.dealerName.disable();
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.RentalCarInfo.mimeType = files[0].type;
    this.RentalCarInfo.image = files[0].name;
    this.rentalCarImageName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat = this.imageService.validateImageFormat(this.RentalCarInfo.mimeType);
    if (isValidFormat) {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.RentalCarInfo.carImageBinaryData = reader.result.toString().replace('data:' + this.RentalCarInfo.mimeType + ';base64,', '');
        this.image = me.imageBaseData;
      };
    }
    reader.onerror = function (_error) {
    };

  }

  async GetAllBrand() {
    await this.EditRentalCar.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      this.brandList = this.brand.slice();
    })
  }

  async onMakeSelected(make: string) {
    this.modelList = [];
    this.RentalCarInfo.model = null;
    if ( make?.trim()) {
      this.GetAllModel(make);
    }
    this.cdr.detectChanges();
  }
  async GetAllModel(make: string): Promise<void> {
    await this.brandService.GetModelnoDropdownList(make).then(data => {
      this.modelList = data.responseObject;
      if (this.modelList?.length == 0) {
        this.RentalCarInfo.model = null;
      }
    });
  }
  async searchVehicle() {
    let licensePlate = this.editRentalCarForm.get('licensePlatNo').value;
    if (licensePlate.trim() == "") {
      return;
    }
    this.spinner.show();
    await this.Vehicleservice.getVehicleByLicencePlateNo(licensePlate).then((response) => {
      this.searchVehicleDetails = response.responseObject;
      if (response.responseObject.errorCount === 1) {
        this.spinner.hide();
        let tpVehicleSearch = false;
        if (this.secureStorage.getKeyData('feature')) {
          this.features = this.secureStorage.getKeyData('feature');
          if (this.features?.length > 0) {
            let feature = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ThirdPartyAPI)?.isActive             
            tpVehicleSearch = feature;
          }
        }
        if (tpVehicleSearch) {
          this.dataFactorySearch(licensePlate);
        } else {
          let noVehicleFound = this.translate.instant("lblVehicleNotFound");
          this.toaster.error(noVehicleFound);
        }
        return;
      }
      this.GetAllModel(this.searchVehicleDetails.companyMakeName);
      this.RentalCarInfo.registrationDateTime = this.searchVehicleDetails.registrationDate;
      this.selectedAttributes = this.searchVehicleDetails.fuelTypeId
      this.editRentalCarForm.patchValue({
        company: this.searchVehicleDetails.companyMakeName,
        model: this.searchVehicleDetails.companyModel,
        color: this.searchVehicleDetails.color,
        year: this.searchVehicleDetails.year,
        engineNo: this.searchVehicleDetails.engineSerialNo,
        chessisNo: this.searchVehicleDetails.chassisNo
      });
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });
  }

  async dataFactorySearch(vehicleNo: string) {
    this.spinner.show();
    let noVehicleFound = this.translate.instant("lblVehicleNotFound");
    await this.Vehicleservice.getVehicleFrmoDataFactoryByLicencePlateNo(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject[0].personDetail == null) {
          this.toaster.error(noVehicleFound);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          if (response.responseObject[0].vehicles != null && response.responseObject[0].vehicles.length > 0) {
            let result = response.responseObject[0].vehicles[0];

            if (!this.empty(result.brandName)) {
              this.GetAllModel(result.brandName);
            }
            this.RentalCarInfo.registrationDateTime = this.empty(result.firstRegistrationDate) ? "" : result.firstRegistrationDate ;
            let fuelType = this.empty(result.fuelTypeText) ? null : result.fuelTypeText ;
            let fuelId = this.fuels.filter(s => s.fuelType.includes(fuelType));
            this.editRentalCarForm.patchValue({
              company: this.empty(result.brandName)  ?null : result.brandName ,
              model: this.empty(result.modelName)? null : result.modelName ,
              color: this.empty(result.colorText)? "" : result.colorText ,
              fuel: (fuelId.length > 0) ? fuelId[0].id : null,
              year: this.empty(result.modelYear) ? 0 : result.modelYear ,
              engineNo: "",
              chessisNo: this.empty(result.vehicleIdentificationNumber) ?"" : result.vehicleIdentificationNumber 
            });
          }
        }
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  EditRentalCarDetails() {
    if (this.rentalCarImageName != null) {
      this.RentalCarInfo.image = this.rentalCarImageName;
    }
    else {
      this.RentalCarInfo.image = null;
    }

    let editMessage = this.translate.instant("lblRentalCarEdited");
    let internalErrorMessage = this.translate.instant("lblRentalCarEditInternalError");
    let alreadyAddedRentalCarMessage = this.translate.instant("lblRentalCarAlreadyAdded");
    const isValidFormat = this.imageService.validateImageFormat(this.RentalCarInfo.mimeType);
    if (isValidFormat) {
      const viewModel: RentalCar = {
        ...this.editRentalCarForm.value,
        image: this.RentalCarInfo.image,
        charges: this.globalSetting.getFormattedprice(this.editRentalCarForm.value.charges.trim()),
        mimeType: this.RentalCarInfo.mimeType,
        carImageBinaryData: this.RentalCarInfo.carImageBinaryData,
        registrationDate: Utility.getDateStringToDate(this.registrationDate),
        dealerId: this.RentalCarInfo.dealerId,
        id: this.id
      }
      this.EditRentalCar.EditRentalCar(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.toaster.success(editMessage);
          localStorage.setItem('lastRentalCar', JSON.stringify(this.RentalCarInfo));
          this.spinner.hide();
          this.activeModal.close({ success: true });
        }
        else if (res.responseCode === Enums.ErrorCodes.InterrnalError) {
          this.spinner.hide();
          this.toaster.error(internalErrorMessage);
        }
        else if (res.responseObject === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          this.toaster.warning(alreadyAddedRentalCarMessage);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }

    this.spinner.hide();
  }

  checkLength(event): void {
    if (event.target.value) {
      let inputValue = event.target.value.toString().trim().replace(/^0+/, '');
      if (inputValue.includes(',') || /\s/.test(inputValue)) {
        this.isValidRentalPrice = inputValue.split(",").length - 1 > 1 || (inputValue.includes('.') && inputValue.includes(','));
        
        if (!this.isValidRentalPrice) {
          const [firstValue] = inputValue.split(',');
          const val = firstValue.replace(/\s/g, '');
          this.isChargesLengthError = val.length > 4;
        } else {
          this.isChargesLengthError = false;
        }
      } else if (inputValue.includes('.')) {
        this.isValidRentalPrice = inputValue.split(".").length - 1 > 1 || (inputValue.includes('.') && inputValue.includes(','));
      
        if (!this.isValidRentalPrice) {
          const [firstValue] = inputValue.split('.');
          const val = firstValue.replace(/\s/g, '');
          this.isChargesLengthError = val.length > 4;
        } else {
          this.isChargesLengthError = false;
        }
      }
      else {
        this.isValidRentalPrice = false;
        this.isChargesLengthError = inputValue.length > 4 ? true : false;
      }

    }
  }
  public selectedDealer(e: any) {
    this.RentalCarInfo.dealerId = this.dealers.find(x => x.name === e).dealerId;
  }

  public selectedFuel(a: number) {
    this.RentalCarInfo.fuel = a;
  }

  public selectedCompany(brand: string) {
    this.RentalCarInfo.company = brand;
  }


}

